/**
 * Users Feature Routes — Product Portal
 */
import type { RouteRecordRaw } from 'vue-router';

export const usersRoutes: RouteRecordRaw[] = [
  {
    path: '/users',
    name: 'users',
    component: () => import('./views/UsersListView.vue'),
    meta: {
      title: 'User Management',
      breadcrumbs: [{ label: 'User Management' }],
      modulePermission: 'userManagement',
    },
  },
];
